import { connect } from 'react-redux';
import LoginScreen from './screen';
import { LoginRequest, showWelcomeScreen } from '../../../redux/actions/CommonActions';

const mapStateToProps = state => {
  return {
    state,
    showTutorialScreen: state.CommonReducer.showTutorialScreen,
    showLogin: state.CommonReducer.showLogin,
    loading: state.LoadingReducer.isLoading,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    dispatchLoginRequest: (loginBody, callback) => dispatch(LoginRequest(loginBody, callback)),
    showWelcomeScreen: () => dispatch(showWelcomeScreen()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginScreen);
